import { useEffect } from 'react'
import { useThree } from '@react-three/fiber'
import { useShallow } from 'zustand/react/shallow'
import { useCADPageStore } from '@/state/cad'

import { GLTFObject } from '@/lib/cad/GLTFObject'
import { WIREFRAME_LAYER } from '@/pages/CADPage/constants'

export const useWireframe = (gltf?: GLTFObject) => {
  const { camera } = useThree()
  const renderMode = useCADPageStore(useShallow((state) => state.renderMode))
  const colorMap = useCADPageStore(useShallow((state) => state.colorMap))
  const isOutlineMode =
    renderMode === 'outline' || renderMode === 'black-and-white-wireframe'
  const isBlackAndWhiteWireframe = renderMode === 'black-and-white-wireframe'

  useEffect(() => {
    if (gltf) {
      if (isOutlineMode) {
        camera.layers.enable(WIREFRAME_LAYER)
      } else {
        camera.layers.disable(WIREFRAME_LAYER)
      }
      gltf.blackAndWhiteWireframe(isBlackAndWhiteWireframe)

      // In B/W mode, re-apply user-set part colors on top of the white baseline.
      if (isBlackAndWhiteWireframe) {
        Object.entries(colorMap).forEach(([partId, color]) => {
          gltf.setColor(partId, color)
        })
      }
    }
  }, [gltf, isOutlineMode, isBlackAndWhiteWireframe, colorMap, camera])
}
